<template>
  <div class="row">
    <w-input class="form-group col-12" :model="schema.firstName" />

    <w-input class="form-group col-12" :model="schema.lastName" />

    <w-input class="form-group col-12" :model="schema.bankAccountNumber" />

    <yes-or-no class="form-group col-12" :model="schema.hasPesel" />

    <w-input class="form-group col-12" :model="schema.pesel" />

    <w-select
      class="form-group col-12"
      :model="schema.identificationDocument.type"
      :values="identificationDocumentTypes"
    />

    <w-input class="form-group col-12" :model="schema.identificationDocument.number" />

    <w-datepicker class="form-group col-12" :model="schema.birthDate" />

    <address-form class="form-group col-12" :model="schema.address" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import AddressForm from '@/components/forms/document/Address.vue';
import YesOrNo from '@/components/forms/document/YesOrNoRadio.vue';
import { Options } from '@/enums/options.enum';

// @vuese
// Formularz danych płatności
// @group Payment
export default {
  components: { ...components, AddressForm, YesOrNo },
  props: {
    // Schema danych płatności
    schema: { type: Object, required: true }
  },

  computed: {
    ...mapState({
      dictionary: state => {
        const dictionary = state.optionValue.options[Options.DICTIONARY]?.value;
        return dictionary && JSON.parse(dictionary);
      }
    }),

    identificationDocumentTypes() {
      return this.dictionary?.identificationDocumentTypes || [];
    }
  }
};
</script>
